import React, { useEffect, useState } from "react";
import { Link } from "./LocalLink";
import { useLanguage } from "../LanguageContext";
import { Cookie } from "lucide-react";

export default function CookieBanner() {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choice = window.localStorage.getItem("bm_cookie_consent");
    if (!choice) {
      const timer = setTimeout(() => setVisible(true), 900);
      return () => clearTimeout(timer);
    }
  }, []);

  const decide = (value) => {
    window.localStorage.setItem("bm_cookie_consent", value);
    setVisible(false);
  };

  if (!visible) return null;
  const c = t.cookies;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[2147483647] px-4 pb-4 sm:px-6 sm:pb-6">
      <div className="mx-auto max-w-4xl rounded-2xl border border-[#E2E8F0] bg-white/95 p-5 shadow-2xl backdrop-blur-md sm:flex sm:items-center sm:gap-5">
        <div className="flex items-start gap-3">
          <span className="mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#E2ECFD] border border-[#AECCF9]">
            <Cookie className="h-4 w-4 text-[#316FD9]" />
          </span>
          <p className="text-sm leading-relaxed text-[#333333]">
            {c.text}{" "}
            <Link to="/legal/cookies" className="font-semibold text-[#316FD9] hover:underline">
              {c.link}
            </Link>
            .
          </p>
        </div>
        <div className="mt-4 flex shrink-0 gap-3 sm:mt-0">
          <button
            onClick={() => decide("rejected")}
            className="flex-1 rounded-lg border border-[#E2E8F0] bg-white px-4 py-2 text-sm font-semibold text-[#333333] hover:bg-[#F8FAFC] transition-colors sm:flex-none"
          >
            {c.reject}
          </button>
          <button
            onClick={() => decide("accepted")}
            className="bm-gradient-btn flex-1 rounded-lg px-5 py-2 text-sm font-semibold text-white sm:flex-none"
          >
            {c.accept}
          </button>
        </div>
      </div>
    </div>
  );
}
